module.exports = __webpack_public_path__ + "img/9_gift.98741748.png";